export default __webpack_public_path__ + "static/media/yt.9f02e29f.png";